// extracted by mini-css-extract-plugin
export var card = "_ka-5";
export var cardSelected = "_ka-4";
export var image = "_ka-3";
export var modal = "_ka-0";
export var modalContent = "_ka-1";
export var table = "_ka-2";